// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","container":"productWithTextCard_container__1BfQ1","title":"productWithTextCard_title__cUAnE"};